import React, { useState, useEffect } from "react";
import { Link, Route } from "react-router-dom";

import { parseISO, format as formatDate } from "date-fns";
import LoadingComponent from "../../../Components/LoadingComponent/index";

const ConsultationsData = (props) => {
  const [consultations, setConsultations] = useState([]);

  useEffect(() => {
    setConsultations(props.consultations);
  }, [props]);

  return (
    <>
      {props?.loading && <LoadingComponent />}
      {props?.loading || (
        <div className="headtable">
          <div className="divtable">
            <div className="hhh consultation-data-header">
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "500",
                  fontFamily: "Poppins",
                }}
              >
                Consultations
              </p>
              {/* <div className="button-status-div">
                <button
                  className="btnview  button-status"
                  style={{
                    ...(!props.activeUnpaid && {
                      backgroundColor: "#17B6DD",
                      color: "white",
                    }),
                  }}
                  onClick={() => props.setActiveUnpaid(false)}
                >
                  Paid
                </button>
                <button
                  style={{
                    ...(props.activeUnpaid && {
                      backgroundColor: "#17B6DD",
                      color: "white",
                    }),
                  }}
                  className="btnview button-status"
                  onClick={() => props.setActiveUnpaid(true)}
                >
                  Unpaid
                </button>
              </div> */}
            </div>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Patient Name</th>
                  {/* <th scope="col">State</th> */}
                  <th style={{ textAlign: "center" }} scope="col">
                    Consultation Type
                  </th>
                  <th style={{ textAlign: "center" }} scope="col">
                    Medical
                  </th>
                  <th scope="col">Booking Start Date</th>
                  <th style={{ textAlign: "center" }} scope="col">
                    Amount
                  </th>
                  <th style={{ textAlign: "center" }} scope="col">
                    Payment Status
                  </th>
                  <th style={{ textAlign: "center" }} scope="col">
                    Status
                  </th>
                  <th style={{ textAlign: "center" }} scope="col">
                    Action
                  </th>
                </tr>
              </thead>
              {consultations.length > 0 &&
                consultations?.map((val, i) => (
                  <tbody>
                    <tr>
                      {/* {console.log(val)} */}
                      <th scope="row">{i + 1}</th>
                      <td>{`${val?.firstName} ${val?.lastName}`}</td>
                      {/* <td>{val?.state}</td> */}
                      {/* <td>{val?.consultationType}</td> */}
                      <td style={{ textAlign: "center" }}>
                        {val.consultationType == "written_report_analysis"
                          ? "Written Report Analysis"
                          : val.consultationType == "phone_call"
                          ? "Phone Call"
                          : "Video Call"}
                      </td>
                      <td style={{ textAlign: "center" }}>{val?.medical}</td>
                      <td>
                        {val.consultationType !== "written_report_analysis"
                          ? formatDate(
                              parseISO(val?.timeSlot?.startTime),
                              "PPp"
                            )
                          : formatDate(parseISO(val?.updatedAt), "PPp")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        ${val?.paidAmount}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          textTransform: "capitalize",
                        }}
                      >
                        <p
                          style={{
                            padding: "10px 12px",
                            borderRadius: "5px",
                            backgroundColor:
                              val?.paymentStatus === "confirmed"
                                ? "#02C4B7"
                                : "red",
                            color: "white",
                          }}
                        >
                          {val?.paymentStatus}
                        </p>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          textTransform: "capitalize",
                        }}
                      >
                        {val?.status}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Link
                          className="link_view"
                          to={`/dashboard/ViewConsutations/${val?._id}`}
                        >
                          <button className="btnview">View</button>
                        </Link>
                      </td>
                    </tr>
                  </tbody>
                ))}
            </table>
            {consultations.length <= 0 && (
              <div
                style={{
                  height: "50px",
                  width: "100%",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                No data
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ConsultationsData;
